import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import { CMD_FEARGREED_REGISTRY_KEY, META_TYPE, META_VER } from './fearGreedCommandRegisteryType';

/**
 * Registers the /cmcfear command with the CommandEngine.
 * Call once at module load from YourLibraryTab (via CommandEngine.bootup).
 *
 * /cmcfear — opens the Fear & Greed index card (single global instance, no market param)
 */
export function registerFearGreedCommand() {
    commandEngine.register('/cmcfear', {
        hint: 'Open fear & greed index',
        params: [],
        handler: () => {
            cardPainterManager.openCard(CMD_FEARGREED_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: 'global' });
        },
    });
}
